import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      width: '100%',
    },
    input: {
      margin: 0,
      '& > input': {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(0),
        lineHeight: '20px',
        height: 'unset',
        '&::placeholder': {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    closeIcon: {
      '&.Mui-focusVisible': {
        border: 'none !important',
      },
    },
    searchIcon: {
      marginRight: theme.spacing(1.5),
      marginLeft: theme.spacing(1.2),
      color: theme.palette.text.secondary,
    },
    startAdornment: {
      marginRight: theme.spacing(0),
      outline: 'none !important',
      backgroundColor: 'white !important',
      borderRadius: '4px',
      borderWidth: '0px',
    },
  })
);
